import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
var _templateObject;
import { css, memoizeStyle } from "../../../lib/theming/Emotion";
export var styles = memoizeStyle({
  calendarRoot: function calendarRoot() {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      width: auto;\n    "])));
  }
});